/* eslint-disable react/require-default-props */
import React, { useState, createRef } from 'react';
import * as Socials from 'react-share';
import {
  StyledContainer,
  StyledSingleItem,
  StyledIconWrapper,
  TWImg,
  ShareIconHolder,
  Icon,
  IconTemp,
} from './styles';
import { Text } from '../Typography';
import { ISocialMediaListComponents } from '../../types/SocialSharing';
import { ShareIcon } from '../Icons/icons';
import { useOnClickOutside } from '../../modules/hooks/useOnClickOutside';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

const SHARE_POS_SOCIAL_SHARE_COMPONENT = 'SocialShareComponent';
const SHARE_POS_PINTEREST_BUTTON = 'PinterestShareButton';

export const SocialSharing = ({
  isGeneric = false,
  id = 'social-sharing',
  sharedItemName,
  sharedItemImage,
  eventEC = 'recipe',
  eventName = `click_share_${eventEC}`,
  socialMediaListComponents,
}: {
  isGeneric?: boolean;
  id?: string;
  sharedItemName: string;
  sharedItemImage: string | undefined;
  eventEC?: string;
  eventName?: string;
  socialMediaListComponents?: ISocialMediaListComponents[];
}) => {
  const handelDataLayerPush = (socialPlatform: ISocialMediaListComponents) => {
    if (!isGeneric) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        eventValues: {
          ec: eventEC,
          ea: `click ${socialPlatform.name} share`,
          el: sharedItemName,
          social_platform: socialPlatform.name,
        },
      });
    }
  };
  return (
    <StyledContainer id={id} data-test={id}>
      {socialMediaListComponents?.map((socialPlatform: ISocialMediaListComponents) => {
        if (
          socialPlatform?.socialSharePosition?.find(
            (element) => element === SHARE_POS_SOCIAL_SHARE_COMPONENT,
          ) ||
          isGeneric
        ) {
          const Item: any = Socials[socialPlatform.socialMediaComponentName];
          const returnJsx = (
            <StyledSingleItem key={socialPlatform.socialMediaComponentName}>
              {socialPlatform.assetsComponents?.[0]?.asset?.[0]?.url && (
                <StyledIconWrapper>
                  <TWImg
                    data-src={socialPlatform?.assetsComponents?.[0].asset[0].url}
                    alt=""
                    className="lazyload"
                    width="18"
                    height="18"
                  />
                </StyledIconWrapper>
              )}
              <Text tag="div" type="md">
                {socialPlatform.shareMsg}
              </Text>
            </StyledSingleItem>
          );
          return (
            <Item
              media={SHARE_POS_PINTEREST_BUTTON && sharedItemImage ? sharedItemImage : undefined}
              url={window.location.href}
              className="m-0"
              key={socialPlatform.socialMediaComponentName}
              data-test={`${id}-${socialPlatform.name}`}
              onClick={() => handelDataLayerPush(socialPlatform)}
            >
              {returnJsx}
            </Item>
          );
        }
        return null;
      })}
    </StyledContainer>
  );
};

export const SocialShareWithIcon = ({
  id = 'social-sharing',
  sharedItemName,
  sharedItemImage,
  socialMediaListComponents,
}: {
  id?: string;
  sharedItemName: string;
  sharedItemImage: string | undefined;
  socialMediaListComponents: ISocialMediaListComponents[];
}) => {
  const [showShare, setShowShare] = useState(false);
  const refContainer = createRef<HTMLDivElement>();
  useOnClickOutside(refContainer, () => setShowShare(false));

  return (
    <>
      <div id={id} data-test={id} className="w-min" ref={refContainer}>
        <ShareIconHolder>
          <Icon
            className="iconShare"
            data-test={`${id}-share-icon`}
            role="button"
            onClick={() => setShowShare(!showShare)}
          >
            <ShareIcon />
          </Icon>
        </ShareIconHolder>
        {showShare && (
          <IconTemp>
            <SocialSharing
              socialMediaListComponents={socialMediaListComponents}
              sharedItemName={sharedItemName}
              sharedItemImage={sharedItemImage}
            />
          </IconTemp>
        )}
      </div>
    </>
  );
};
